<template>
    <div>
        <app-section>
            <heading
                :header="heading"
                :asset="page.image.length > 0 ? page.image[0] : false"
                :grid="true"
                :share="false"
            >
                <template v-slot:after>
                    <div class="t-content">
                        <anim-text v-if="page.desc !== null" :cms="true" :text="page.desc" />
                    </div>
                </template>
            </heading>
        </app-section>

        <builder :builder="page.builder" />

        <push />
    </div>
</template>

<script>
import AppSection from "layout/AppSection";
import Blob from "objects/Blob";
import AnimText from "objects/AnimText";
import Heading from "components/Heading";
import Btn from "components/Btn";
import Push from "components/Push";
import Builder from "builder/Builder";

export default {
    name: "Landing",
    components: {
        AppSection,
        Blob,
        AnimText,
        Heading,
        Builder,
        Btn,
        Push
    },
    props: {
        page: Object
    },
    metaInfo() {
        return {
            title: this.page.seo.title
        };
    },
    computed: {
        currentRoute() {
            return this.$router.currentRoute;
        },
        isLanding() {
            return this.currentRoute.name === "landing";
        },
        heading() {
            return {
                sup: false,
                mainTitle: this.page.title,
                headingLevel: "h1",
                desc: this.page.customTitle
            };
        }
    }
};
</script>

<style lang="scss">
.p-post {
}

.p-post__nav {
    margin-top: var(--section-padding);
    margin-bottom: var(--section-padding);

    @media #{md("sm")} {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

.p-post__siblings {
    display: flex;
    align-items: center;

    @media #{md("sm", "max")} {
        width: 100%;
    }
}

/*==================================
=            User infos            =
==================================*/

.o-user {
}

.o-user__header {
    display: flex;

    @media #{md("xs", "max")} {
        flex-direction: column;
    }
}

.o-user__profile {
    display: flex;
    align-items: flex-end;
    margin-right: auto;
}

.o-user__name,
.o-user__photo {
    flex-shrink: 0;
}

.o-user__photo {
    --size: 6em;
    margin-right: 1em;
}

.o-user__name {
    @media #{md("xs", "max")} {
        top: -2rem;
    }
}

.o-user__postdate {
    @media #{md("xs", "max")} {
        margin-top: -2rem;
        margin-left: 7rem !important;
        padding-top: 0;

        &:before {
            display: none !important;
        }
    }
}

.o-user__desc {
    padding-top: 1em;
    padding-bottom: 1em;
    color: $color-grey-dark;
    border-bottom: $border-grey;
}
</style>
